import React from 'react';
import { Flex, Box, Spacer } from '@chakra-ui/react';

import ListPanelItem from 'sharedComponents/ListPanelItem';

import type { Client } from 'generated/graphql';
import { clientListName } from 'sharedHelpers/clientHelpers';
import Badge from 'sharedComponents/Badge';

interface ScheduleListPanelChildrenProps {
  clientsData: Client[];
  style: React.CSSProperties;
  index: number;
}

// This is (as of 5/2022) a copy of ClientListPanelItem.  The two are expected
// to diverge with time.
const ScheduleListPanelChildren = (
  props: ScheduleListPanelChildrenProps
): JSX.Element => {
  const { clientsData, style, index } = props;
  if (!clientsData.length) {
    return <></>;
  }

  const client = clientsData[index];

  const { lastSend, carrier } = client || {};

  return client ? (
    <ListPanelItem key={client.id} id={client.id} style={style}>
      <Flex>
        <Box alignSelf="flex-end">{clientListName(client)}</Box>
        <Spacer />
        <Badge
          lastSend={lastSend || ''}
          carrierType={carrier?.type || ''}
          color="brand.orange1"
        />
      </Flex>
    </ListPanelItem>
  ) : (
    <></>
  );
};

export default React.memo(ScheduleListPanelChildren);
